import { parsePhoneNumberFromString } from 'libphonenumber-js';
import memoize from 'lodash/memoize';

export const getFormattedPhoneNumber = memoize(
  (phoneNumber?: string | null): string => {
    if (!phoneNumber) {
      return '';
    }
    const parsed = parsePhoneNumberFromString(phoneNumber);
    if (!parsed) {
      return phoneNumber;
    }
    if (parsed.country === 'FR') {
      return parsed.formatNational();
    }
    return parsed.formatInternational();
  },
);
